
import { CadastroForm, initializeCadastroForm } from './CadastroForm.js';
import { PropertyResults, PropertyResultsManager } from './PropertyResults.js';


export function KadasterPage() {
    return (async () => {
        // Render the CadastroForm and PropertyResults
        // advertenciasBox code verwijderd
        return `
            <div id="header-container"></div>
            ${await CadastroForm({ formId: 'cadastro' })}
            <div class="flex justify-center w-full">
                <div class="container max-w-4xl mt-8 px-4">
                    ${PropertyResults()}
                    <div id="property-results-container"></div>
                </div>
            </div>
        `;
    })();
}

// Initialize the Kadaster page
export function initializeKadasterPage() {
    // Initialize the cadastro form functionality
    initializeCadastroForm();
    
    // Check voor error data van PropertyResults redirect
    checkAndDisplayErrorData();
    
    // ✅ Extra poging om formulierwaarden te herstellen na error redirect
    setTimeout(() => {
        if (window.cadastroAppInstance && window.cadastroAppInstance.restoreFormValues) {
            window.cadastroAppInstance.restoreFormValues();
        }
    }, 500);

    // Catastro-kaart knop en logica verwijderd
}

// Controleer en toon error data als die beschikbaar is
function checkAndDisplayErrorData() {
    const errorDataString = sessionStorage.getItem('cadastroErrorData');
    if (!errorDataString) return;
    
    try {
        const errorData = JSON.parse(errorDataString);
        
        // Controleer of de data niet te oud is (max 5 minuten)
        const maxAge = 5 * 60 * 1000; // 5 minuten
        if (Date.now() - errorData.timestamp > maxAge) {
            sessionStorage.removeItem('cadastroErrorData');
            return;
        }
        
        // Initialiseer PropertyResults manager en toon de data
        const propertyResultsManager = new PropertyResultsManager('property-results-container');
        
        // Wacht even tot de elementen geladen zijn
        setTimeout(() => {
            propertyResultsManager.displayResults(
                errorData.result, 
                errorData.propertyData, 
                `${errorData.searchType} (redirigido por error 43)`,
                false  // Geen uitklapmenu, toon alles direct
            );
            
            // Scroll naar de resultaten
            const resultsContainer = document.getElementById('property-results-container');
            if (resultsContainer) {
                resultsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100);
        
        // Eliminar los datos de error de sessionStorage después de su uso
        sessionStorage.removeItem('cadastroErrorData');
        
    } catch (error) {
        // Error al analizar los datos de error de cadastro
        sessionStorage.removeItem('cadastroErrorData');
    }
}

async function fetchParcelInfo(lat, lng, map) {
    try {
        const url = `https://www1.sedecatastro.gob.es/OVCWS/OVCService.svc/Consulta_Coordenadas`;
        const body = {
            Coordenadas: {
                x: lng,
                y: lat,
                SRS: "EPSG:4326"
            }
        };

        const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json"
            }
        });

        const data = await response.json();

        if (!data || !data.Consulta_CoordenadasResult) {
            return;
        }

        const parcela = data.Consulta_CoordenadasResult.parcela;

        if (!parcela) {
            L.popup()
                .setLatLng([lat, lng])
                .setContent("No se encontró parcela en esta ubicación.")
                .openOn(map);
            return;
        }

        const info = `
            <b>Parcela encontrada</b><br>
            Provincia: ${parcela.Provincia}<br>
            Municipio: ${parcela.Municipio}<br>
            Ref. Catastral: ${parcela.Ref_Catastral}
        `;

        L.popup()
            .setLatLng([lat, lng])
            .setContent(info)
            .openOn(map);

    } catch (err) {
        // Error al obtener información de la parcela
    }
}
// Initialiseer de Kadasterkaart
// initializeKadasterMap is verwijderd
